import { render, staticRenderFns } from "./DialogLoading.vue?vue&type=template&id=1f0af831&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/tonyj/Documents/Proyectos/lastedchange/transit-web/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VProgressLinear})
